// /home/Hakyury/sites/frameparty.eight-percent.com/frontend/src/App.js
import { BrowserRouter as Router } from "react-router-dom";
import React, { useEffect } from "react";
import { useInitAuth } from './hooks/useInitAuth';
import { setTokens } from "./utils/authFetch";
import FramePartyApp from './frameparty/FramePartyApp';

function App() {
  useInitAuth();

  // Обработчик сообщений от других окон (для других сайтов)
  useEffect(() => {
    const handleMessage = (event) => {
      // Принимаем сообщения только от доверенных источников
      const allowedOrigins = [
        'https://eight-percent.com',
        'https://campfire.eight-percent.com',
        'https://etoile.eight-percent.com',
        'https://frameparty.eight-percent.com',
        'https://profile.eight-percent.com',
        'https://admin.eight-percent.com',
        'http://localhost:3000',
        'http://127.0.0.1:3000',
      ];

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      if (event.data.type === 'oauth_success') {
        const { access_token, refresh_token } = event.data;
        setTokens({ access: access_token, refresh: refresh_token });
        console.log('Tokens received via postMessage');
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Router>
      <FramePartyApp />
    </Router>
  );
}

export default App;
